export default __webpack_public_path__ + "static/media/arrowRightSlider.e3b25ba1.svg";